module.exports = __webpack_public_path__ + "img/xt2@2x.5956e140.png";